import { Common, color } from '@stockbit/ui';
import styled from 'styled-components';

const { Button } = Common;

const StockFollowButton = styled(Button)`
  width: 100px;
  height: 36px;
  border-radius: 5px;
  background: ${color.light} !important;
  border: 1px solid
    ${(props) =>
      props.type === 'primary' ? `${color.lowgray}` : `${color.primary}`};
  color: ${(props) =>
    props.type === 'primary' ? `${color.nightRider}` : `${color.primary}`};

  &:hover, &:focus {
    border: 1px solid
      ${(props) =>
        props.type === 'primary'
          ? `${color.lowgray} !important`
          : `${color.primary} !important`};
  }
`;

export { StockFollowButton };
